import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { HasFormComponent } from '../../../core/interfaces/hasFormComponent';

@Component({
  selector: 'ndms-data-display',
  templateUrl: './ndms-data-display.component.html',
  styleUrls: ['./ndms-data-display.component.scss']
})
export class NdmsDataDisplayComponent extends NdmsFormControlComponent implements OnInit {
  @Input() text: string;

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);

    let parentComponent = (<any>viewContainerRef.injector).view.component;

    if(parentComponent instanceof NdmsFormControlComponent) {
      this.label = parentComponent.label;
      this.group = parentComponent.group;
      this.field = parentComponent.field;
    }

    if(parentComponent instanceof HasFormComponent) {
      this.group = parentComponent.form
    }
  }

  getText() {
    if(this.text) {
      return this.text;
    }

    let field= this.group.get(this.field);

    if(!field) {
      throw `Field "${this.field}" is missing from the form group`;
    }

    let fieldValue = field.value;

    return fieldValue !== undefined ? fieldValue : 'N/A';
  }

  ngOnInit() {
  }

}
